// Lives in a framework-free shared lib because the parser (frontend + backend) and the backend file
// DTO must agree on one taxonomy; backend-libs is unreachable from psd-parser-core.
export enum AssetRoleEnum {
  PREVIEW = 'preview',
  MASK = 'mask',
  SMART_OBJECT_SOURCE = 'smart-object-source',
  FRAME_OVERLAY = 'frame-overlay',
  CONTENT = 'content',
  // Retired from its library, not deleted: copies already placed on a spread resolve by storage url.
  HIDDEN = 'hidden',
  // A photographer's ready JPG spread or cover: placed as a whole page, never a photo of the book.
  READY_SPREAD = 'ready-spread',
}

export const SERVICE_ASSET_ROLES: readonly AssetRoleEnum[] = [
  AssetRoleEnum.PREVIEW,
  AssetRoleEnum.MASK,
  AssetRoleEnum.SMART_OBJECT_SOURCE,
  AssetRoleEnum.FRAME_OVERLAY,
  AssetRoleEnum.HIDDEN,
  AssetRoleEnum.READY_SPREAD,
] as const;

export function isServiceAssetRole(role: AssetRoleEnum | null | undefined): boolean {
  return role != null && SERVICE_ASSET_ROLES.includes(role);
}
